import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Alert } from "react-bootstrap";
import { wrapComponentWithProvider } from "../../../containers/root-view/RootView";

import store from "./store";
import * as selectors from "./state-selectors/email-verify-input";
import * as actions from "./actions/email-verify-input";
import InputFieldDeprecated from "../input-field/InputFieldDeprecated";

export class EmailVerifyInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailError: false
    };
    this.verifyEmail = this.props.verifyEmail.bind(this);
    this.handleChange = this.props.handleChange;
    this.placeholder = this.props.placeholder;
    this.validation = {
      // validation messages for different input validation attributes
      message: {
        required: "Email is required",
        pattern: "Please enter a valid email address"
      },
      // can be string of event name or list of event names
      validateOn: ["blur", "keyup"],
      checkValidity: this.validate.bind(this)
    };

    if (this.props.overrideEmail) {
      setTimeout(() => {
        this.props.handleEmailOverride(this.props.overrideEmail);
        this.verifyEmail();
      });
    }
  }

  componentDidCatch(err) {
    console.log(err);
  }

  updateErrorStateEmail(val) {
    this.setState({
      emailError: val
    });
  }

  validate(val, isFormSubmitted) {
    if (this.props.emailVerifyAttempted || isFormSubmitted) {
      if (!val) {
        return {
          isValid: false,
          inputAttr: "required"
        };
      }

      return {
        isValid:
          window.globalConfig.validation.patterns.email.test(val) &&
          !val.includes("www."),
        inputAttr: "pattern"
      };
    } 
      return {
        isValid: this.props.emailVerified
      };
    
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.inputErrorState !== this.state.emailError) {
      this.setState({
        emailError: nextProps.inputErrorState
      });
    }
  }

  componentWillUnmount() {
    setTimeout(this.props.reset);
  }

  render() {
    const { email } = this.props;

    return (
      <div style={{ position: "relative" }}>
        <InputFieldDeprecated
          id="refereeEmail"
          name="email"
          type="email"
          value={email}
          placeholder={this.placeholder}
          handleChange={this.handleChange}
          handleBlur={this.verifyEmail}
          validation={this.validation}
          validationError={this.state.emailError}
          updateErrorState={this.updateErrorStateEmail.bind(this)}
        />
      </div>
    );
  }
}

EmailVerifyInput.propTypes = {
  email: PropTypes.string,
  overrideEmail: PropTypes.string,
  verifyEmail: PropTypes.func,
  placeholder: PropTypes.string,
  performVerification: PropTypes.bool
};

const mapStateToProps = state => ({
    email: selectors.getEmail(state),
    emailVerified: selectors.emailVerified(state),
    emailVerifyAttempted: selectors.emailVerifyAttempted(state),
    inputErrorState: selectors.getInputErrorState(state)
  });

const mapDispatchToProps = dispatch => ({
    verifyEmail(value, isInputError) {
      const { email, emailVerifyAttempted } = this.props;
      const performVerification = !emailVerifyAttempted;

      if (
        typeof email !== "undefined" &&
        email.length > 1 &&
        performVerification
      ) {
        dispatch(actions.verifyEmail(email, isInputError));
      } else {
        this.handleChange(value, isInputError);
      }
    },
    handleChange: (val, isInputError) => {
      dispatch(actions.emailChanged(val));
      dispatch(actions.checkEmailInputState(isInputError));
    },
    handleEmailOverride: email => {
      dispatch(actions.emailOverride(email));
    },
    reset: () => {
      dispatch(actions.reset());
    }
  });

const ConnectedEmailVerifyInput = connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailVerifyInput);
export default wrapComponentWithProvider(ConnectedEmailVerifyInput, store);
